module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    attrs: {
      "id": "toc"
    }
  }, [_c('h1', {
    attrs: {
      "id": "toc-title"
    }
  }, [_vm._v("The Magic Toy Shop")]), _vm._v(" "), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-1"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch001#about-the-author"
    }
  }, [_vm._v("About the Author")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-2"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch002#dedication"
    }
  }, [_vm._v("Dedication")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-3"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch003#copyright-information"
    }
  }, [_vm._v("Copyright Information©")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-4"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch004#chapter-1-the-enchanted-village"
    }
  }, [_vm._v("Chapter 1: The Enchanted Village")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-5"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch005#chapter-2-the-village-toy-shop",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 2: The Village Toy Shop")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-6"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch006#chapter-3-the-magic-comes-alive",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 3: The Magic Comes Alive")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-7"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch007#chapter-4-a-name-and-a-new-friend",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 4: A Name and a New Friend")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-8"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch008#chapter-5-a-winter-crisis",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 5: A Winter Crisis")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-9"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch009#chapter-6-the-magic-of-christmas",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 6: The Magic of Christmas")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-10"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch010#chapter-7-maisies-terrible-boxing-day",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 7: Maisie’s Terrible Boxing Day")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-11"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch011#chapter-8-a-decision-to-sell-the-shop",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 8: A Decision to Sell the Shop\n          ")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-12"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch012#chapter-9-the-birthday-party",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 9: The Birthday Party")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-13"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch013#chapter-10-maisie-gets-her-dad-back",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 10: Maisie Gets Her Dad Back")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-14"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch014#chapter-11-a-troublesome-addition-to-the-family",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 11: A Troublesome Addition to the Family")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-15"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch015#chapter-12-maisie-has-an-insecure-moment",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 12: Maisie Has an Insecure Moment")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-16"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch016#chapter-13-a-magical-touch-of-kindness",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 13: A Magical Touch of Kindness")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-17"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch017#chapter-14-mums-and-daughters-friendship-grows",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 14: Mum’s and Daughter’s Friendship Grows")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-18"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch018#chapter-15-martha-believes-she-is-different",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 15: Martha Believes She is Different")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-19"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch019#chapter-16-the-toy-robot-mystery",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 16: The Toy Robot Mystery\n          ")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-20"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch020#chapter-17-revenge-is-so-sweet-for-maisie",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 17: Revenge is so Sweet for Maisie")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-21"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch021#chapter-18-a-school-project-stirs-it-all-up-again",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 18: A School Project Stirs it all up Again")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-22"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch022#chapter-19-the-school-loses-its-favourite-maths-teacher",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 19: The School Loses its Favourite Maths Teacher")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-23"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch023#chapter-20-a-lively-village-loses-its-personality",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 20: A Lively Village Loses its Personality")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-41e49fa1","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/nav.vue
// module id = 60
// module chunks = 0